import { useState } from 'react';

export default function StartScreen({ identity, onStart, onBack }) {
  const [confirmedWired, setConfirmedWired] = useState(false);
  const [confirmedAppsClosed, setConfirmedAppsClosed] = useState(false);
  const [confirmedWorkHours, setConfirmedWorkHours] = useState(false);

  const allConfirmed = confirmedWired && confirmedAppsClosed && confirmedWorkHours;
  const firstName = identity?.full_name?.split(' ')[0] || 'there';

  const start = () => {
    if (!allConfirmed) return;
    onStart({
      confirmed_wired: confirmedWired,
      confirmed_apps_closed: confirmedAppsClosed,
      confirmed_work_hours: confirmedWorkHours
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">Hi {firstName}</h1>
        <p className="mt-2 text-slate-600">
          This is a baseline connection check, not an employment decision. Most runs take about 7 to 8 minutes, but slower connections can take longer while the app records the actual network response.
        </p>
        <p className="mt-2 text-sm text-slate-500">
          We check browser and computer readiness, then measure download speed, upload speed, packet loss, jitter, latency, bufferbloat, WebSocket round-trip, and voice-quality signals against a Convertros test server.
        </p>
      </div>

      <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700 space-y-3">
        <p className="font-medium text-slate-900">Please confirm before starting:</p>

        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={confirmedWired}
            onChange={e => setConfirmedWired(e.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-500"
          />
          <span>I am using a wired ethernet connection where possible.</span>
        </label>

        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={confirmedAppsClosed}
            onChange={e => setConfirmedAppsClosed(e.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-500"
          />
          <span>I have closed other browser tabs and bandwidth-heavy apps (streaming, cloud sync, video calls).</span>
        </label>

        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={confirmedWorkHours}
            onChange={e => setConfirmedWorkHours(e.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-500"
          />
          <span>I am running this during the time of day I would actually be working.</span>
        </label>
      </div>

      <div className="flex items-center gap-3">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            className="rounded-md border border-slate-300 bg-white px-4 py-2 text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-500"
          >
            Back
          </button>
        ) : null}
        <button
          type="button"
          onClick={start}
          disabled={!allConfirmed}
          className="rounded-md bg-slate-900 px-4 py-2 text-white shadow hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-500 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Start test
        </button>
      </div>
    </div>
  );
}
